import * as React from 'react'
import styled from 'styled-components'

import * as api from '@owl-nest/api-client/latest'
import * as date from '@owl-nest/date'
import { t } from '@owl-nest/localize'
import * as models from '@owl-nest/models'
import * as plume from '@ulule/owl-kit-components/next'
import * as services from '@owl-nest/services'
import * as utils from '@owl-nest/utils'

type CommentProps = {
  className?: string
  comment: api.Comment
  onDelete: () => void
  onReply: () => void
}

export function Comment({ className, comment, onDelete, onReply }: CommentProps): React.ReactElement {
  const auth = services.user.useAuth()
  // const canDeleteComment = isUserStaff || isCommentAuthor

  return (
    <Wrapper className={className}>
      <plume.UserLabel
        avatar={models.user.avatar(comment.user, '90x90')}
        href={comment.user.absolute_url}
        name={models.user.fullName(comment.user)}
        avatarSize="extra-small"
        tag={models.user.tag(comment.user, comment.user.role)}
      />

      <Body>
        <plume.styles.copy.S dangerouslySetInnerHTML={{ __html: utils.linkify(comment.comment) }} />

        <Footer>
          <plume.styles.heading.XXXXXS
            as="time"
            dateTime={comment.submit_date}
            title={date.format(new Date(comment.submit_date), 'PPPP pppp')}
          >
            {date.formatDistanceToNow(new Date(comment.submit_date))}
          </plume.styles.heading.XXXXXS>
          {auth.type === 'loggedin' && (
            <>
              <plume.LinkAsButton onClick={onReply} tinted uppercase>
                {t('Reply')}
              </plume.LinkAsButton>
              {/*{canDeleteComment && (*/}
              {/*  <DeleteCTA kind="secondary" onClick={onDelete} uppercase>*/}
              {/*    {t('Delete')}*/}
              {/*  </DeleteCTA>*/}
              {/*)}*/}
            </>
          )}
        </Footer>
      </Body>
    </Wrapper>
  )
}

const Wrapper = styled.article`
  display: flex;
  flex-direction: column;
  padding-bottom: 14px;
`

const Body = styled.div`
  ${plume.styles.copy.S}, ${plume.styles.copy.M} {
    margin: 10px 0;
  }
`

const DeleteCTA = styled(plume.LinkAsButton)`
  margin-left: auto;
`

const Footer = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: row;
`
